// Store simples para o carrinho usando localStorage
export default {
  getCarrinho() {
    const carrinho = localStorage.getItem('carrinho')
    return carrinho ? JSON.parse(carrinho) : []
  },

  adicionarItem(produto, quantidade = 1) {
    const carrinho = this.getCarrinho()
    // Suporta id ou produtoId (compatível com APIs que usam nomenclaturas diferentes)
    const produtoId = produto.id ?? produto.produtoId
    if (produtoId == null) return carrinho

    const itemExistente = carrinho.find(item => item.id === produtoId)
    
    if (itemExistente) {
      itemExistente.quantidade += quantidade
      // Atualiza metadados úteis ao re-adicionar o mesmo produto
      if (produto.planoFunerario != null) itemExistente.planoFunerario = !!produto.planoFunerario
      if (produto.habilitarRetirada != null) itemExistente.habilitarRetirada = !!produto.habilitarRetirada
      if (produto.tipo != null) itemExistente.tipoProduto = produto.tipo
    } else {
      // Suporta valor ou preco (planos do assistente podem vir com estruturas diferentes)
      const valor = produto.valor ?? produto.preco ?? 0
      carrinho.push({
        id: produtoId,
        nome: produto.nome ?? produto.descricao ?? 'Produto',
        descricao: produto.descricao ?? '',
        valor: Number(valor) || 0,
        imagem: produto.imagem ?? null,
        quantidade: quantidade,
        qtdEstoque: produto.qtdEstoque ?? 999,
        // Metadados para checkout (termo de aceite, regras) — não afetam totais
        tipoProduto: produto.tipo ?? null,
        planoFunerario: produto.planoFunerario === true,
        habilitarRetirada: produto.habilitarRetirada === true
      })
    }
    
    localStorage.setItem('carrinho', JSON.stringify(carrinho))
    return carrinho
  },

  removerItem(produtoId) {
    const carrinho = this.getCarrinho().filter(item => item.id !== produtoId)
    localStorage.setItem('carrinho', JSON.stringify(carrinho))
    return carrinho
  },

  atualizarQuantidade(produtoId, quantidade) {
    const carrinho = this.getCarrinho()
    const item = carrinho.find(item => item.id === produtoId)
    
    if (item) {
      if (quantidade <= 0) {
        return this.removerItem(produtoId)
      }
      item.quantidade = quantidade
    }
    
    localStorage.setItem('carrinho', JSON.stringify(carrinho))
    return carrinho
  },

  limparCarrinho() {
    localStorage.removeItem('carrinho')
    return []
  },

  getTotal() {
    const carrinho = this.getCarrinho()
    return carrinho.reduce((total, item) => total + (item.valor * item.quantidade), 0)
  },

  getTotalItens() {
    const carrinho = this.getCarrinho()
    return carrinho.reduce((total, item) => total + item.quantidade, 0)
  }
}

